import { MODULE_IDS } from '@tahi/core';
import { useEffect } from 'react';
import { useCommandEnv, useModuleStates, useUsableModules } from './hooks';
import { noteUsableModules } from './moduleHooks';

/**
 * Renders nothing. Whenever the usable module list changes (app start, a toggle made here or
 * pulled from another device, an admin override from /api/me), runs the module usable hooks.
 */
export function ModuleHooksRunner() {
  const env = useCommandEnv();
  const usable = useUsableModules();
  const { data: states } = useModuleStates();
  const key = MODULE_IDS.filter((id) => usable[id]).join(',');
  const loaded = states !== undefined;

  useEffect(() => {
    if (!loaded) return; // module_states not read yet
    void noteUsableModules(
      MODULE_IDS.filter((id) => usable[id]),
      env,
    );
    // `key` captures the usable list; env changes with it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, env, loaded]);

  return null;
}
